// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import './Button.scss';

function ButtonLink({
  children,
  to,
  className,
  ...rest
}) {
  const styleClasses = classNames('Button', className);

  return (
    <Link
      {...rest}
      to={to}
      className={styleClasses}
    >
      {children}
    </Link>
  );
}

ButtonLink.defaultProps = {
  className: '',
};

export default ButtonLink;
